import { createContext } from "../../utils/createContext.mjs";
const PRESENCE_CHILD_ATTR = "data-ap-child";
const [injectAnimatePresence, provideAnimatePresence] = createContext("AnimatePresenceContext");
export {
  PRESENCE_CHILD_ATTR,
  injectAnimatePresence,
  provideAnimatePresence
};
